import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { Select, Tab, TabGroup, Badge } from 'excellence-ui';
import { HasRoleDirective } from '../../../../shared/directives/has-role';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-supplier-contracts-details-nav',
  imports: [
    RouterLink,
    RouterLinkActive,
    TabGroup,
    Tab,
    NgIcon,
    Select,
    HasRoleDirective,
    TranslocoPipe,
    Badge,
  ],
  templateUrl: './supplier-contracts-details-nav.html',
})
export class SupplierContractsDetailsNav {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  contractCheckAlerts = input.required<number>();

  protected onSelectChange(url: string | string[] | null): void {
    this.router.navigate([url], {
      relativeTo: this.activatedRoute,
    });
  }
}
